import request from './request';
import api from './api';

const { mealAccess, mealDetail, mealRefreshQrcode } = api;

export function getToken(params = {}) {
  return request('GET', mealAccess, params);
}

export function getMealDetail(params = {}) {
  return request('POST', mealDetail, params);
}

export function getQrcode(params = {}) {
  return request('POST', mealRefreshQrcode, params);
}
